import React from 'react';

/**
 * Reflow-optimized SVG Logo.
 * Eliminates pathLength/getTotalLength DOM geometry queries for zero forced reflows.
 */
export const Logo = ({ className = "w-8 h-8" }: { className?: string }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="boxGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#6366f1" />
      </linearGradient>
      <filter id="glow">
        <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
        <feMerge>
          <feMergeNode in="coloredBlur"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>

    {/* Isometric Box Outline */}
    <path
      d="M50 15 L85 35 L85 65 L50 85 L15 65 L15 35 Z"
      stroke="url(#boxGradient)"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="transition-opacity duration-700"
    />
    
    {/* Internal Structure - Y shape for cube depth */}
    <path
      d="M50 15 V 50 M50 50 L85 35 M50 50 L15 35"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      opacity="0.2"
    />

    {/* Central Pulsing Neural Node */}
    <circle
      cx="50"
      cy="50"
      r="8"
      fill="url(#boxGradient)"
      filter="url(#glow)"
      className="animate-pulse"
    />

    {/* Connected Peripheral Nodes */}
    {[
      { cx: 30, cy: 40 },
      { cx: 70, cy: 40 },
      { cx: 50, cy: 70 },
    ].map((node, i) => (
      <React.Fragment key={i}>
        <line
          x1="50" y1="50" x2={node.cx} y2={node.cy}
          stroke="currentColor"
          strokeWidth="1"
          strokeDasharray="4 4"
          opacity="0.3"
        />
        <circle
          cx={node.cx}
          cy={node.cy}
          r="3"
          fill="currentColor"
          className="text-emerald-400 animate-pulse"
        />
      </React.Fragment>
    ))}

    {/* Subtle Waveform Pulse */}
    <path
      d="M25 50 Q 37.5 45, 50 50 T 75 50"
      stroke="currentColor"
      strokeWidth="1"
      opacity="0.3"
    />
  </svg>
);
